import React from 'react';
import { 
  Box, 
  Typography, 
  Button,
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  Paper 
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';

const ProductDetailCartosat3 = () => {
  const history = useHistory();

  return (
    <Box sx={{ maxWidth: '1200px', mx: 'auto', p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          sx={{
            color: '#4287f5',
            textTransform: 'none',
            fontWeight: 500
          }}
          onClick={() => history.push('/products')}
        >
          Products &gt; Cartosat-3
        </Button>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }}>
          Product Description
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.primary', lineHeight: 1.6 }}>
          Cartosat-3 is an advanced high-resolution Earth observation satellite developed by the Indian Space Research Organisation (ISRO). Launched in 2019, it represents a significant advancement in India's remote sensing capabilities, offering sub-meter resolution imagery for detailed mapping and monitoring applications.
          <br /><br />
          The satellite features advanced imaging technology with both panchromatic and multispectral capabilities, providing exceptional spatial resolution and spectral information. Cartosat-3 operates in a sun-synchronous orbit, enabling systematic coverage and frequent revisits of target areas.
          <br /><br />
          With its enhanced imaging capabilities, Cartosat-3 supports a wide range of applications including urban planning, infrastructure development, precision agriculture, disaster management, defense applications, and large-scale mapping projects. The satellite's high-resolution imagery enables detailed analysis of terrain, structures, and land use patterns with unprecedented clarity.
        </Typography>
      </Box>

      <TableContainer component={Paper} sx={{ mb: 4, border: '1px solid #d0d7de', boxShadow: 'none' }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f0f4fa' }}>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Geographical Coverage</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Image Resolution</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Swath Width</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Revisit Frequency</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Data Format</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow hover>
              <TableCell align="center">Global*</TableCell>
              <TableCell align="center">0.25 m x 0.25 m (PAN), 1.1 m (MS)</TableCell>
              <TableCell align="center">16 km</TableCell>
              <TableCell align="center">4-5 days</TableCell>
              <TableCell align="center">GeoTIFF</TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={5} sx={{ fontStyle: 'italic', fontSize: '0.85rem', color: 'gray', py: 1 }}>
                *Global coverage available. AOI outside India requires additional processing time.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Table sx={{ mt: 4 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f0f4fa' }}>
              <TableCell sx={{ fontWeight: 600, color: '#1976d2' }}>Spectral Band</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1976d2' }}>Wavelength Range</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1976d2' }}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow hover>
              <TableCell>Panchromatic (PAN)</TableCell>
              <TableCell>450 - 800 nm</TableCell>
              <TableCell>Ultra-high resolution panchromatic band for detailed imaging and cartographic applications.</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell>Blue (B)</TableCell>
              <TableCell>450 - 520 nm</TableCell>
              <TableCell>Blue spectral band for water body detection and atmospheric correction.</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell>Green (G)</TableCell>
              <TableCell>520 - 590 nm</TableCell>
              <TableCell>Green spectral band for vegetation analysis and land cover classification.</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell>Red (R)</TableCell>
              <TableCell>630 - 690 nm</TableCell>
              <TableCell>Red spectral band for vegetation health assessment and soil discrimination.</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell>Near-Infrared (NIR)</TableCell>
              <TableCell>770 - 860 nm</TableCell>
              <TableCell>Near-infrared band for vegetation vigor analysis and biomass estimation.</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
        <Button
          variant="contained"
          sx={{
            bgcolor: '#1976d2',
            color: 'white',
            py: 1,
            px: 4,
            '&:hover': {
              bgcolor: '#1565c0'
            }
          }}
        >
          Order Imagery
        </Button>
      </Box>
    </Box>
  );
};

export default ProductDetailCartosat3;

